import { DateTime } from 'luxon';

const dateTimeToInputDate = (date?: DateTime) =>
  date?.isValid ? date.toFormat('MM-dd-yyyy') : undefined;

export default dateTimeToInputDate;
